import {StandingsFilterTypeModel} from "./standings.filter-type.model";
import {StandingsDestinationDomainModel} from "./destinations/standings.destinations.domain-model";
import {StandingsDomainModel} from "./standings.domain-model";
import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {GroupDomainModel} from "../../common/group/models/group.domain-model";
import {StandingsDestinationViewModel} from "./destinations/standings.destinations.view-model";
import {StandingsRowDomainModel} from "./row/standings.row-domain-model";
import {StandingsHeaderViewModel} from "./header/standings-header.view-model";
import {CompetitionViewModel} from "../../common/competition/models/competition-view-model";
import {StandingsGroupCategoryViewModel} from "./group-category/standings.group-category.view-model";
import {StandingsGroupCategoryDomainModel} from "./group-category/standings.group-category.domain-model";
import {StandingsWidgetCellViewModel} from "../../../widgets/standings-widget/models/standings-widget.cell-view-model";
import {STANDINGS_WIDGET} from "../../../widgets/standings-widget/standings-widget.consts";
import {StandingsCompetitionRulesViewModel} from "./competition-rules/standings.competition-rules.view-model";
import {StandingsPointsDeductionViewModel} from "./points-deductions/standings.points-deduction.view-model";

export class StandingsViewModel extends BaseViewModel {
  domainModel: StandingsDomainModel;
  onlyMajorColumns: Boolean;

  constructor(domainModel: StandingsDomainModel, onlyMajorColumns: Boolean = false) {
    super(domainModel);

    this.onlyMajorColumns = onlyMajorColumns;
  }

  get rows(): StandingsRowDomainModel {
    return this.domainModel?.rows
  }

  get competition(): CompetitionViewModel {
    return new CompetitionViewModel(this.domainModel.competition)
  }

  get displayName(): String {
    return this.domainModel.displayName;
  }

  get headers(): Array<StandingsHeaderViewModel> {
    let hasPointsCell = false;

    const headers: Array<StandingsHeaderViewModel> = this.domainModel.headers?.filter(header => !this.onlyMajorColumns || header.isMajor)?.map(header => {
      hasPointsCell |= [STANDINGS_WIDGET.PTS_KEY].includes(header.key);

      return new StandingsHeaderViewModel(header, [STANDINGS_WIDGET.PTS_KEY].includes(header.key))
    });

    const lastMajorHeader:StandingsWidgetCellViewModel = headers?.filter((header) => header.isMajor)?.last();

    if(lastMajorHeader && !hasPointsCell) {
      lastMajorHeader.isBold = true;
    }

    return headers;
  }

  get destinations(): Array<StandingsDestinationViewModel> {
    const destinations: Array<StandingsDestinationViewModel> = this.domainModel.destinations?.map((destination: StandingsDestinationDomainModel) => new StandingsDestinationViewModel(destination));

    return destinations;
  }

  get seasonNum(): Number {
    return this.domainModel.seasonNum;
  }

  get stageNum(): Number {
    return this.domainModel.stageNum;
  }

  get isCurrentStage(): Boolean {
    return this.domainModel.isCurrentStage;
  }

  get groups(): Array<GroupDomainModel> {
    return this.domainModel.groups;
  }

  get filterTypes(): Array<StandingsFilterTypeModel> {
    return this.domainModel.filterTypes;
  }

  get currentGroupCategory(): Number {
    return this.domainModel.currentGroupCategory;
  }

  get groupCategories(): Array<StandingsGroupCategoryViewModel> {
    const groupCategories: Array<StandingsGroupCategoryViewModel> = this.domainModel.groupCategories?.map((group: StandingsGroupCategoryDomainModel) => new StandingsGroupCategoryViewModel(group));

    return groupCategories;
  }


  get winnerDescription(): String {
    return this.domainModel.winnerDescription;
  }

  get competitionRules(): CompetitionViewModel {
    return this.domainModel.competitionRules && new StandingsCompetitionRulesViewModel(this.domainModel.competitionRules)
  }

  get pointsDeductions(): Array<StandingsPointsDeductionViewModel> {
    return this.domainModel.pointsDeductions?.length > 0 ? this.domainModel.pointsDeductions.map(point => new StandingsPointsDeductionViewModel(point)) : null
  }
}
